import React from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormCheck } from "go-form";
import { ApplicationApi } from "../../../../../../../../../services/Api/Organization/types";
import AppStocksLinkingForm from "../AppStocksLinkingForm";
import GoPosCustomFieldsForm from "../GoPos/GoPosCustomFieldsForm";
import MultilocationCustomFieldsForm from "./MultilocationCustomFieldsForm";
import MultilocationSyncDocumentsCustomFieldsForm from "./MultilocationSyncDocumentsCustomFieldsForm";

interface Props {
	form: UseFormReturn<ApplicationApi>;
	config: Record<string, any>;
}

const MultilocationDownloadingDataForm = ({ form, config }: Props) => {
	const {
		formState: { errors },
		register,
	} = form;
	const { t } = useTranslation();

	return (
		<>
			<h5>{t("modules.app.field.downloading_data.title")}</h5>
			<fieldset>
				<div className="row mb-3">
					<div className="col-md-6 form-check-container">
						<FormCheck
							errors={errors}
							register={register}
							type="switch"
							name="settings.IMPORT_PRODUCTS"
							label={t("modules.app.field.import_products.title")}
							help={t("modules.app.field.import_products.help_text")}
						/>
					</div>
					<div className="col-md-6 form-check-container">
						<FormCheck
							errors={errors}
							register={register}
							type="switch"
							name="settings.AUTO_CREATE_IMPORTED_PRODUCTS"
							label={t("modules.app.field.auto_create_imported_products.title")}
							help={t("modules.app.field.auto_create_imported_products.help_text")}
						/>
					</div>
				</div>
				<div className="row mb-3">
					<div className="col-md-6 form-check-container">
						<FormCheck
							errors={errors}
							register={register}
							type="switch"
							name="settings.UPDATE_IMPORTED_PRODUCTS"
							label={t("modules.app.field.update_imported_products.title")}
							help={t("modules.app.field.update_imported_products.help_text")}
						/>
					</div>
					<div className="col-md-6 form-check-container">
						<FormCheck
							errors={errors}
							register={register}
							type="switch"
							name="settings.SKIP_UPDATE_OF_CRITICAL_AND_OPTIMAL_PRODUCT_STATE"
							label={t("modules.app.field.skip_update_of_critical_and_optimal_product_state.title")}
							help={t("modules.app.field.skip_update_of_critical_and_optimal_product_state.help_text")}
						/>
					</div>
				</div>
				<div className="row mb-3">
					<div className="col-md-6 form-check-container">
						<FormCheck
							errors={errors}
							register={register}
							type="switch"
							name="settings.AUTO_LINKED_NAME"
							label={t("modules.app.field.auto_linked_name.title")}
							help={t("modules.app.field.auto_linked_name.help_text")}
						/>
					</div>
					<div className="col-md-6 form-check-container">
						<FormCheck
							errors={errors}
							register={register}
							type="switch"
							name="settings.AUTO_LINKED_SKU"
							label={t("modules.app.field.auto_linked_sku.title")}
							help={t("modules.app.field.auto_linked_sku.help_text")}
						/>
					</div>
				</div>
				<div className="row mt-5 mb-3">
					<div className="col-md-6 form-check-container">
						<FormCheck
							errors={errors}
							register={register}
							type="switch"
							name="settings.AUTO_CREATE_IMPORTED_PRODUCT_CATEGORIES"
							label={t("modules.app.field.auto_create_imported_product_categories.title")}
							help={t("modules.app.field.auto_create_imported_product_categories.help_text")}
						/>
					</div>
					<div className="col-md-6 form-check-container">
						<FormCheck
							errors={errors}
							register={register}
							type="switch"
							name="settings.UPDATE_IMPORTED_PRODUCT_CATEGORIES"
							label={t("modules.app.field.update_imported_product_categories.title")}
							help={t("modules.app.field.update_imported_product_categories.help_text")}
						/>
					</div>
				</div>
				<div className="row mb-3">
					<div className="col-md-6 form-check-container">
						<FormCheck
							errors={errors}
							register={register}
							type="switch"
							name="settings.IMPORT_CONTACTS"
							label={t("modules.app.field.import_contacts.title")}
							help={t("modules.app.field.import_contacts.help_text")}
						/>
					</div>
					<div className="col-md-6 form-check-container">
						<FormCheck
							errors={errors}
							register={register}
							type="switch"
							name="settings.AUTO_CREATE_IMPORTED_CONTACTS"
							label={t("modules.app.field.auto_create_imported_contacts.title")}
							help={t("modules.app.field.auto_create_imported_contacts.help_text")}
						/>
					</div>
				</div>
				<div className="row mb-3">
					<div className="col-md-6 form-check-container">
						<FormCheck
							errors={errors}
							register={register}
							type="switch"
							name="settings.UPDATE_IMPORTED_CONTACTS"
							label={t("modules.app.field.update_imported_contacts.title")}
							help={t("modules.app.field.update_imported_contacts.help_text")}
						/>
					</div>
					<div className="col-md-6 form-check-container">
						<FormCheck
							errors={errors}
							register={register}
							type="switch"
							name="settings.IMPORT_ROLES"
							label={t("modules.app.field.import_roles.title")}
							help={t("modules.app.field.import_roles.help_text")}
						/>
					</div>
				</div>
				<div className="row mb-3">
					<div className="col-md-6 form-check-container">
						<FormCheck
							errors={errors}
							register={register}
							type="switch"
							name="settings.IMPORT_ORDERS"
							label={t("modules.app.field.import_orders.title")}
							help={t("modules.app.field.import_orders.help_text")}
						/>
					</div>
				</div>
				<AppStocksLinkingForm form={form} config={config} />
				<MultilocationSyncDocumentsCustomFieldsForm form={form} config={config} />
				<MultilocationCustomFieldsForm form={form} config={config} />
				<div className="row mt-5 mb-3">
					<div className="col-12 form-check-container">
						<FormCheck
							errors={errors}
							register={register}
							type="switch"
							name="settings.AUTO_LINK_CHANNEL_LINKEDS_BY_REFERENCE_IDS"
							label={t("modules.app.field.auto_link_channel_linkeds_by_reference_ids.title")}
							help={t("modules.app.field.auto_link_channel_linkeds_by_reference_ids.help_text")}
						/>
					</div>
				</div>
			</fieldset>
		</>
	);
};

export default MultilocationDownloadingDataForm;
